import { render, staticRenderFns } from "./EvaluationRecommendRow.vue?vue&type=template&id=b983f02c&scoped=true"
import script from "./EvaluationRecommendRow.vue?vue&type=script&lang=js"
export * from "./EvaluationRecommendRow.vue?vue&type=script&lang=js"
import style0 from "./EvaluationRecommendRow.vue?vue&type=style&index=0&id=b983f02c&prod&lang=css"
import style1 from "./EvaluationRecommendRow.vue?vue&type=style&index=1&id=b983f02c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b983f02c",
  null
  
)

export default component.exports